<nb-card class="list">
  <nb-card-header class="list__header">
    {{ title }}
  </nb-card-header>
  <ng-content></ng-content>
</nb-card>
